


































































import { Component, Vue } from "vue-property-decorator";
import { resetPassword, createNewPassword } from "@/services/security/authService";
import { PasswordReset } from "@/services/security/types";
import i18n from "@/i18n";

@Component
export default class ResetPassword extends Vue {
    email = "";
    password = "";
    cofirmPassword = "";
    token = "";
    passswordReset = {} as PasswordReset;
    message = i18n.t("");

    created() {
        this.token = this.$route.query.token ? this.$route.query.token.toString() : "";
        this.email = this.$route.query.email ? this.$route.query.email.toString() : "";
    }

    get passwordResetingMode() {
        return !!(Object.entries(this.passswordReset).length > 0 && this.passswordReset.constructor === Object);
    }

    get passwordMatch() {
        return this.password === this.cofirmPassword;
    }

    resetPass() {
        resetPassword(this.email, "Reset password from login page").then(response => {
            this.passswordReset = response;
            this.token = "";
            this.passswordReset.mailSent ? this.message = i18n.t("login.checkEmail") : this.message = i18n.t("login.mailNotSent");
            this.passswordReset.somethingBadHappen ? this.message = i18n.t("login.incorectEmail") : this.email = "";
        });
    }

    savePass(): void {
        createNewPassword(this.email, this.password, this.token).then(response => {
            this.passswordReset = response;
            this.token = "";
            this.passswordReset.passwordReseted ? this.message = i18n.t("login.goToLogin") : this.message = i18n.t("login.tryAgain");
            this.passswordReset.somethingBadHappen ? this.message = i18n.t("login.incorectEmail") : this.email = "";
            console.log(this.token);
        });
    }
}
